/* eslint-disable @typescript-eslint/no-inferrable-types */
import { SmBaseEntity } from "src/modules/sm-base/shared/sm-base-entity.model";
import { Column, Entity } from "typeorm";

@Entity()
export class CustomsNumber extends SmBaseEntity {
    @Column({default: ""})
    customsNumber: string = "";

    @Column({default: ""})
    descriptionGerman: string = "";

    @Column({default: ""})
    descriptionEnglish: string = "";

    @Column({default: ""})
    descriptionFrench: string = "";

    @Column({default: ""})
    descriptionSpanish: string = "";
}